import { toast } from "react-toastify";

export const SESSION_EXPIRED_MESSAGE =
  "Oturumunuz sona erdi, lütfen tekrar giriş yapın";

const SESSION_EXPIRED_FLASH_KEY = "sessionExpiredMessage";
const SESSION_EXPIRED_TOAST_ID = "session-expired";
const AUTH_STORAGE_KEYS = [
  "accessToken",
  "accessTokenExpiration",
  "refreshToken",
  "refreshTokenExpires",
  "role",
  "roleId",
  "companyId",
  "userId",
  "rld",
  "isRemember",
];

let isSessionExpiryHandled = false;

export const clearAuthenticationSession = () => {
  [localStorage, sessionStorage].forEach((storage) => {
    AUTH_STORAGE_KEYS.forEach((key) => storage.removeItem(key));
  });
};

export const expireSession = () => {
  if (isSessionExpiryHandled) return;

  isSessionExpiryHandled = true;
  clearAuthenticationSession();

  if (window.location.pathname === "/giris-yap") {
    toast.error(SESSION_EXPIRED_MESSAGE, { toastId: SESSION_EXPIRED_TOAST_ID });
    return;
  }

  sessionStorage.setItem(SESSION_EXPIRED_FLASH_KEY, SESSION_EXPIRED_MESSAGE);
  window.location.replace("/giris-yap");
};

export const consumeSessionExpiryMessage = () => {
  const message = sessionStorage.getItem(SESSION_EXPIRED_FLASH_KEY);
  sessionStorage.removeItem(SESSION_EXPIRED_FLASH_KEY);
  return message;
};
